import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {Flex, Box} from 'reflexbox';
import {inject, observer} from 'mobx-react';

// import {style} from "variables/Variables.jsx";
import {FormGroup, ControlLabel, FormControl, Row} from 'react-bootstrap';
import {Card, CardTitle, CardText, Slider} from 'react-md';
import Footer from "../../component/Footer";
import {getParameterByName} from '../../util/uitl';
import {MemberRegisterForm} from "../../component/event/RegisterForm";
import PersonRegisterForm from "../../component/event/RegisterPersonForm";
import RegisterSuccessCard from "../../component/event/RegisterSuccessCard";
import RegisterFailCard from "../../component/event/RegisterFail";

@inject('EventStore')
@withRouter
@observer
export class SelfRegisterPage extends Component {
    constructor(props) {
        super(props)
        this.entryType = getParameterByName(('entry'));
        this.eventId = getParameterByName(('event'));

    }

    componentDidMount() {
        this.props.EventStore.load(this.eventId);
    }

    renderChild(stateFlow) {
        let display;
        if (stateFlow === 0) {
            if (this.entryType === 'member') {
                this.props.EventStore.requestType = 'member';
                display = (
                    <Card className="reg-card md-block-centered">
                        <MemberRegisterForm/>
                    </Card>
                    );
            } else {
                this.props.EventStore.requestType = 'person';
                display = (
                    <Card className="reg-card md-block-centered">
                        <PersonRegisterForm/>
                    </Card>
                )
            }
        }
        return display;
    }

    renderResult(stateFlow) {
        let display;
        if (stateFlow === 1) {
            display = (<RegisterSuccessCard member={this.props.EventStore.member}/>);
        } else if (stateFlow === 255) {
            display = (<RegisterFailCard result={this.props.EventStore.result}/>);
        }
        return display;
    }


    render() {
        return (
            <div className="wrapper">
                <div id="register-page">
                    {this.renderChild(this.props.EventStore.stateFlow)}
                    {this.renderResult(this.props.EventStore.stateFlow)}
                </div>
                <footer className="footer-cert">
                    <Flex>
                        <p className="copyright pull-right">
                            &copy; {(new Date()).getFullYear()} Champ of Champ Innovation
                        </p>
                    </Flex>
                </footer>
            </div>
        );
    }
}

export default SelfRegisterPage;



// WEBPACK FOOTER //
// ./src/views/EventSelfRegister/SelfRegister.jsx